/* MAKA · comportamenti del tema (menu, carrello, caroselli, ricerca nelle offerte) */
(function () {
  'use strict';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isDesktop = function () { return window.matchMedia('(min-width: 990px)').matches; };
  var overlay = document.querySelector('[data-maka-overlay]');
  var openLayers = new Set();

  function setOverlay() {
    if (!overlay) return;
    overlay.classList.toggle('is-on', openLayers.size > 0);
    document.body.classList.toggle('maka-lock', openLayers.has('drawer'));
  }

  /* ---------- Menu "Tutte le categorie" (computer) ---------- */
  var megaBtn = document.querySelector('[data-maka-mega]');
  var mega = document.querySelector('[data-maka-mega-panel]');
  var megaTimer;
  function openMega() {
    if (!mega) return;
    clearTimeout(megaTimer);
    mega.classList.add('is-open');
    megaBtn && megaBtn.setAttribute('aria-expanded', 'true');
    openLayers.add('mega'); setOverlay();
  }
  function closeMega() {
    if (!mega) return;
    mega.classList.remove('is-open');
    megaBtn && megaBtn.setAttribute('aria-expanded', 'false');
    openLayers.delete('mega'); setOverlay();
  }
  function closeMegaSoon() { clearTimeout(megaTimer); megaTimer = setTimeout(closeMega, 220); }
  if (megaBtn && mega) {
    megaBtn.addEventListener('click', function () { mega.classList.contains('is-open') ? closeMega() : openMega(); });
    megaBtn.addEventListener('mouseenter', function () { if (isDesktop()) openMega(); });
    megaBtn.addEventListener('mouseleave', function () { if (isDesktop()) closeMegaSoon(); });
    mega.addEventListener('mouseenter', function () { clearTimeout(megaTimer); });
    mega.addEventListener('mouseleave', function () { if (isDesktop()) closeMegaSoon(); });
    var items = mega.querySelectorAll('[data-maka-mega-item]');
    var panes = mega.querySelectorAll('[data-maka-mega-pane]');
    var show = function (n) {
      items.forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-maka-mega-item') === n); });
      panes.forEach(function (p) { p.classList.toggle('is-on', p.getAttribute('data-maka-mega-pane') === n); });
    };
    items.forEach(function (b) {
      var n = b.getAttribute('data-maka-mega-item');
      b.addEventListener('mouseenter', function () { show(n); });
      b.addEventListener('focus', function () { show(n); });
      b.addEventListener('click', function () { show(n); });
    });
  }

  /* ---------- Pannello categorie (telefono) ---------- */
  var catDrawer = document.querySelector('[data-maka-catdrawer]');
  var catOpener = null;
  function openCats(e) {
    if (!catDrawer) return;
    catOpener = e && e.currentTarget;
    catDrawer.classList.add('is-open');
    openLayers.add('drawer'); setOverlay();
    var c = catDrawer.querySelector('[data-maka-catdrawer-close]');
    c && setTimeout(function () { c.focus(); }, 50);
  }
  function closeCats() {
    if (!catDrawer || !catDrawer.classList.contains('is-open')) return;
    catDrawer.classList.remove('is-open');
    openLayers.delete('drawer'); setOverlay();
    catOpener && catOpener.focus();
  }
  document.querySelectorAll('[data-maka-catdrawer-open]').forEach(function (b) { b.addEventListener('click', openCats); });
  document.querySelectorAll('[data-maka-catdrawer-close]').forEach(function (b) { b.addEventListener('click', closeCats); });
  overlay && overlay.addEventListener('click', function () { closeMega(); closeCats(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeMega(); closeCats(); } });

  /* ---------- Carrello: apri, conta, animazione ---------- */
  function openCart() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') { drawer.open(); return; }
    window.location.href = (window.routes && window.routes.cart_url) || '/cart';
  }
  document.querySelectorAll('[data-maka-open-cart]').forEach(function (b) { b.addEventListener('click', openCart); });

  function paintCount(n) {
    document.querySelectorAll('[data-maka-cart-count]').forEach(function (el) {
      var changed = el.textContent.trim() !== String(n);
      el.textContent = n;
      el.setAttribute('data-count', n);
      if (changed && !reduceMotion) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }
    });
  }
  function refreshCount() {
    fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { paintCount(c.item_count); })
      .catch(function () {});
  }
  document.querySelectorAll('[data-maka-cart-count]').forEach(function (el) { el.setAttribute('data-count', el.textContent.trim()); });
  function hookPubSub() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(refreshCount, 60); });
      return true;
    }
    return false;
  }
  if (!hookPubSub()) document.addEventListener('DOMContentLoaded', hookPubSub);

  function cartTarget() {
    var list = isDesktop()
      ? document.querySelectorAll('#cart-icon-bubble')
      : document.querySelectorAll('.maka-tabbar [data-maka-open-cart], #cart-icon-bubble');
    for (var i = 0; i < list.length; i++) {
      var r = list[i].getBoundingClientRect();
      if (r.width && r.height) return r;
    }
    return null;
  }
  function fly(fromEl) {
    if (reduceMotion || !fromEl || !fromEl.animate) return;
    var a = fromEl.getBoundingClientRect();
    var b = cartTarget();
    if (!b) return;
    var dot = document.createElement('span');
    dot.className = 'maka-fly';
    dot.style.left = (a.left + a.width / 2 - 13) + 'px';
    dot.style.top = (a.top + a.height / 2 - 13) + 'px';
    document.body.appendChild(dot);
    var dx = b.left + b.width / 2 - (a.left + a.width / 2);
    var dy = b.top + b.height / 2 - (a.top + a.height / 2);
    dot.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1 },
      { transform: 'translate(' + dx * 0.5 + 'px,' + (dy * 0.5 - 90) + 'px) scale(1.15)', opacity: 1, offset: 0.5 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.4)', opacity: 0.2 }
    ], { duration: 700, easing: 'cubic-bezier(.5,0,.4,1)' }).onfinish = function () { dot.remove(); };
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    var btn = form.querySelector('[type="submit"]') || e.submitter;
    fly(e.submitter || btn);
  }, true);

  /* Pulsante preferenze cookie: nascosto mentre il carrello laterale è aperto */
  (function () {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !window.MutationObserver) return;
    new MutationObserver(function () {
      var open = drawer.classList.contains('active');
      document.querySelectorAll('.iubenda-tp-btn').forEach(function (b) {
        if (open) b.style.setProperty('display', 'none', 'important'); else b.style.removeProperty('display');
      });
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  })();

  /* Anteprima Shopify: la barra nera dell'anteprima non deve coprire la barra in basso */
  (function () {
    var tries = 0, lastH = -1;
    var t = setInterval(function () {
      var bar = document.getElementById('PBarNextFrameWrapper');
      if (bar) {
        var h = Math.round(bar.getBoundingClientRect().height);
        if (!isDesktop()) h = Math.max(h, 64);
        if (h > 0 && h !== lastH) {
          lastH = h;
          document.documentElement.style.setProperty('--maka-pbar', h + 'px');
          document.body.classList.add('maka-pbar');
        }
      }
      if (++tries > 20) clearInterval(t);
    }, 500);
  })();

  /* ---------- Banner a carosello ---------- */
  document.querySelectorAll('[data-maka-hero]').forEach(function (hero) {
    var track = hero.querySelector('[data-maka-hero-track]');
    if (!track) return;
    var slides = track.children;
    var dots = hero.querySelectorAll('.maka-hero__dots span');
    var idx = 0;
    var go = function (i) {
      if (!slides.length) return;
      idx = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[idx].offsetLeft - track.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
    };
    var onScroll = function () {
      var w = track.clientWidth || 1;
      var n = Math.round(track.scrollLeft / w);
      idx = n;
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === n); });
    };
    track.addEventListener('scroll', function () { window.requestAnimationFrame(onScroll); }, { passive: true });
    var prev = hero.querySelector('[data-maka-hero-prev]');
    var next = hero.querySelector('[data-maka-hero-next]');
    prev && prev.addEventListener('click', function () { go(idx - 1); restart(); });
    next && next.addEventListener('click', function () { go(idx + 1); restart(); });
    var secs = parseInt(hero.getAttribute('data-autoplay'), 10) || 0;
    var timer = null;
    var paused = false;
    function restart() {
      clearInterval(timer);
      if (!secs || reduceMotion || slides.length < 2) return;
      timer = setInterval(function () { if (!paused && !document.hidden) go(idx + 1); }, secs * 1000);
    }
    hero.addEventListener('mouseenter', function () { paused = true; });
    hero.addEventListener('mouseleave', function () { paused = false; });
    hero.addEventListener('touchstart', function () { paused = true; }, { passive: true });
    hero.addEventListener('touchend', function () { setTimeout(function () { paused = false; }, 4000); }, { passive: true });
    hero.addEventListener('focusin', function () { paused = true; });
    hero.addEventListener('focusout', function () { paused = false; });
    restart();
  });

  /* ---------- Prodotti simili: cerca nel negozio i prodotti con la stessa parola chiave ---------- */
  document.querySelectorAll('[data-maka-similar]').forEach(function (sec) {
    var kw = sec.getAttribute('data-keyword');
    var pid = sec.getAttribute('data-pid');
    var limit = parseInt(sec.getAttribute('data-limit'), 10) || 12;
    var track = sec.querySelector('[data-maka-row-track]');
    if (!kw || !track) return;
    var url = '/search?type=product&options%5Bprefix%5D=last&view=maka-similar&q=' + encodeURIComponent(kw);
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('ul');
      tmp.innerHTML = html;
      var found = [].slice.call(tmp.querySelectorAll('li[data-pid]')).filter(function (li) { return li.getAttribute('data-pid') !== pid; });
      if (found.length < 3) return;
      var have = {};
      found.forEach(function (li) { have[li.getAttribute('data-pid')] = 1; });
      var keep = found.slice(0, limit);
      if (keep.length < limit) {
        [].slice.call(track.children).forEach(function (li) {
          if (keep.length >= limit) return;
          var id = li.getAttribute('data-pid');
          if (id && (have[id] || id === pid)) return;
          keep.push(li);
        });
      }
      track.innerHTML = '';
      keep.forEach(function (li) { track.appendChild(li); });
      track.dispatchEvent(new Event('scroll'));
      var shopSec = sec.closest('.shopify-section');
      if (shopSec) shopSec.style.setProperty('display', 'block', 'important');
    }).catch(function () {});
  });

  /* ---------- File di prodotti con frecce ---------- */
  document.querySelectorAll('[data-maka-row]').forEach(function (row) {
    var track = row.querySelector('[data-maka-row-track]');
    var prev = row.querySelector('[data-maka-row-prev]');
    var next = row.querySelector('[data-maka-row-next]');
    if (!track) return;
    var update = function () {
      var max = track.scrollWidth - track.clientWidth - 2;
      prev && (prev.disabled = track.scrollLeft <= 2);
      next && (next.disabled = track.scrollLeft >= max);
    };
    var step = function (dir) { track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: reduceMotion ? 'auto' : 'smooth' }); };
    prev && prev.addEventListener('click', function () { step(-1); });
    next && next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  /* ---------- Barra di acquisto in basso (scheda prodotto, telefono) ---------- */
  document.querySelectorAll('[data-maka-buybar]').forEach(function (bar) {
    var sectionId = bar.getAttribute('data-section');
    var mainBtn = function () { return document.getElementById('ProductSubmitButton-' + sectionId); };
    var priceEl = bar.querySelector('[data-maka-buybar-price]');
    var syncPrice = function () {
      var src = document.querySelector('#price-' + sectionId + ' .price-item--sale, #price-' + sectionId + ' .price__regular .price-item--regular');
      var onSale = document.querySelector('#price-' + sectionId + ' .price--on-sale');
      if (onSale) src = onSale.querySelector('.price-item--sale') || src;
      if (src && priceEl) priceEl.textContent = src.textContent.trim();
      var b = mainBtn();
      var barBtn = bar.querySelector('[data-maka-buybar-btn]');
      if (b && barBtn) {
        barBtn.disabled = b.disabled;
        var label = b.querySelector('span');
        if (label) barBtn.textContent = label.textContent.trim();
      }
    };
    bar.querySelector('[data-maka-buybar-btn]').addEventListener('click', function () {
      var b = mainBtn();
      if (b && !b.disabled) b.click();
    });
    /* compare solo quando si sono superati "Aggiungi al carrello" e i pulsanti di pagamento veloce */
    var btn = mainBtn();
    var target = btn && (btn.closest('.product-form') || btn.closest('product-form') || btn);
    if (target) {
      var lastOn = null, ticking = false;
      var check = function () {
        ticking = false;
        var on = target.getBoundingClientRect().bottom < 130;
        if (on === lastOn) return;
        lastOn = on;
        bar.classList.toggle('is-on', on);
        document.body.classList.toggle('maka-buybar-on', on);
      };
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; window.requestAnimationFrame(check); } }, { passive: true });
      check();
    }
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(syncPrice, 80); });
    }
    syncPrice();
  });

  /* ---------- Disponibilità nel riquadro acquisto ---------- */
  function hookStock() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return false;
    subscribe(PUB_SUB_EVENTS.variantChange, function (ev) {
      var d = ev && ev.data;
      if (!d) return;
      var root = document.getElementById('MainProduct-' + d.sectionId) || document;
      root.querySelectorAll('[data-maka-stock]').forEach(function (el) {
        var ok = d.variant && d.variant.available;
        el.textContent = ok ? 'Disponibile' : 'Al momento non disponibile';
        el.classList.toggle('is-out', !ok);
      });
    });
    return true;
  }
  if (!hookStock()) document.addEventListener('DOMContentLoaded', hookStock);

  /* ---------- Ricerca dentro una collezione (Offerte): parole chiave + categoria ---------- */
  document.querySelectorAll('[data-maka-colsearch]').forEach(function (box) {
    var input = box.querySelector('[data-maka-colsearch-input]');
    var chipsWrap = box.querySelector('[data-maka-colsearch-chips]');
    var results = box.querySelector('[data-maka-colsearch-results]');
    var countEl = box.querySelector('[data-maka-colsearch-count]');
    var moreBtn = box.querySelector('[data-maka-colsearch-more]');
    var empty = box.querySelector('[data-maka-colsearch-empty]');
    var grid = document.getElementById('ProductGridContainer');
    var gridSection = grid && grid.closest('.shopify-section');
    var hideEls = gridSection ? [gridSection] : [];
    var url = box.getAttribute('data-url');
    var money = box.getAttribute('data-money') || '{{amount_with_comma_separator}} €';
    var data = null, loading = null, cat = '', shown = 0, matches = [];

    var norm = function (s) {
      return (s || '').toString().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/ø/g, 'o');
    };
    var fmt = function (cents) {
      var v = (cents / 100).toFixed(2).split('.');
      var intp = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return money.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, intp + ',' + v[1]);
    };
    var handleize = function (t) { return norm(t).replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); };
    var inCat = function (p, c) {
      if (c.indexOf('tag:') === 0) {
        var t = c.slice(4);
        return (p._t || (p._t = (p.tags || []).map(handleize))).indexOf(t) > -1;
      }
      return (p.cols || []).indexOf(c) > -1;
    };
    var esc = function (s) { return (s || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

    function load() {
      if (data) return Promise.resolve(data);
      if (loading) return loading;
      var all = [];
      var page = 1;
      var next = function () {
        return fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'view=maka-index&page=' + page)
          .then(function (r) { return r.json(); })
          .then(function (j) {
            all = all.concat(j.products || []);
            if (j.next && page < 40) { page++; return next(); }
            data = all;
            if (chipsWrap) {
              chipsWrap.querySelectorAll('[data-cat]').forEach(function (b) {
                var c = b.getAttribute('data-cat');
                if (c && !all.some(function (p) { return inCat(p, c); })) b.hidden = true;
              });
            }
            return all;
          });
      };
      loading = next().catch(function () { data = all; return all; });
      return loading;
    }

    function card(p) {
      var off = p.compare > p.price ? Math.round((1 - p.price / p.compare) * 100) : 0;
      return '<li class="maka-mini-card"><a href="' + esc(p.url) + '">' +
        (off ? '<span class="maka-mini-card__tag">−' + off + '%</span>' : '') +
        '<span class="maka-mini-card__im">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy" width="300" height="300">' : '') + '</span>' +
        '<span class="maka-mini-card__t">' + esc(p.title) + '</span>' +
        '<span class="maka-mini-card__p"><b>' + fmt(p.price) + '</b>' + (off ? ' <s>' + fmt(p.compare) + '</s>' : '') + '</span>' +
        '<span class="maka-card-ship">Spedizione gratis</span>' +
        (p.available ? '' : '<span class="maka-mini-card__out">Esaurito</span>') +
        '</a></li>';
    }

    function paint(reset) {
      if (reset) { results.innerHTML = ''; shown = 0; }
      var slice = matches.slice(shown, shown + 24);
      results.insertAdjacentHTML('beforeend', slice.map(card).join(''));
      shown += slice.length;
      moreBtn.hidden = shown >= matches.length;
    }

    function run() {
      var q = norm(input.value.trim());
      var active = q.length > 0 || cat !== '';
      hideEls.forEach(function (el) { el.hidden = active; });
      box.classList.toggle('is-active', active);
      if (!active) { results.innerHTML = ''; countEl.textContent = ''; moreBtn.hidden = true; empty.classList.remove('is-on'); return; }
      countEl.textContent = 'Cerco…';
      load().then(function (list) {
        var words = q.split(/\s+/).filter(Boolean);
        matches = list.filter(function (p) {
          if (cat && !inCat(p, cat)) return false;
          if (!words.length) return true;
          var hay = p._h || (p._h = norm(p.title + ' ' + p.type + ' ' + (p.tags || []).join(' ') + ' ' + p.vendor + ' ' + (p.skus || []).join(' ')));
          return words.every(function (w) { return hay.indexOf(w) > -1; });
        });
        countEl.textContent = matches.length === 1 ? '1 prodotto trovato' : matches.length + ' prodotti trovati';
        empty.classList.toggle('is-on', matches.length === 0);
        paint(true);
      });
    }

    var t;
    input.addEventListener('input', function () { clearTimeout(t); t = setTimeout(run, 180); });
    input.addEventListener('focus', function () { load(); }, { once: true });
    if (chipsWrap) {
      var prune = function () { load(); };
      if ('requestIdleCallback' in window) requestIdleCallback(prune, { timeout: 4000 }); else setTimeout(prune, 2500);
    }
    box.querySelector('form').addEventListener('submit', function (e) { e.preventDefault(); run(); input.blur(); });
    chipsWrap && chipsWrap.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cat]');
      if (!b) return;
      cat = b.getAttribute('data-cat');
      chipsWrap.querySelectorAll('[data-cat]').forEach(function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      run();
    });
    moreBtn.addEventListener('click', function () { paint(false); });
    var clear = box.querySelector('[data-maka-colsearch-clear]');
    clear && clear.addEventListener('click', function () {
      input.value = ''; cat = '';
      chipsWrap && chipsWrap.querySelectorAll('[data-cat]').forEach(function (x, k) { x.classList.toggle('is-on', k === 0); });
      run();
    });
  });
})();

/* Menu categorie: la voce toccata resta evidenziata (con rotellina) mentre si apre la pagina */
document.addEventListener('click', function (e) {
  var a = e.target.closest('.maka-catdrawer a.maka-acc__sub, .maka-catdrawer a.maka-acc');
  if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey) return;
  document.querySelectorAll('.maka-catdrawer .is-going').forEach(function (x) { x.classList.remove('is-going'); });
  a.classList.add('is-going');
});
window.addEventListener('pageshow', function () { document.querySelectorAll('.maka-catdrawer .is-going').forEach(function (x) { x.classList.remove('is-going'); }); });
/* iPhone: senza questo il colore "al tocco" (:active) non si vede */
document.addEventListener('touchstart', function () {}, { passive: true });
/* Scheda prodotto (computer): passando col mouse su una miniatura cambia la foto grande, come su Amazon */
(function () {
  var mq = window.matchMedia('(hover: hover) and (min-width: 990px)');
  document.addEventListener('mouseover', function (e) {
    if (!mq.matches) return;
    var b = e.target.closest('.maka-pp .thumbnail-list .thumbnail');
    if (!b || b.hasAttribute('aria-current')) return;
    b.click();
  });
  /* tiene visibile la miniatura scelta nella colonna (es. quando si cambia variante) */
  document.addEventListener('click', function (e) {
    if (!mq.matches || !e.target.closest('variant-selects, .maka-pp .thumbnail-list')) return;
    setTimeout(function () {
      var cur = document.querySelector('.maka-pp .thumbnail-list .thumbnail[aria-current]');
      var list = cur && cur.closest('.thumbnail-list');
      if (!list) return;
      var li = cur.parentElement, top = li.offsetTop, bot = top + li.offsetHeight;
      if (top < list.scrollTop || bot > list.scrollTop + list.clientHeight) list.scrollTo({ top: top - 8, behavior: 'smooth' });
    }, 700);
  });
})();
/* Varianti con tante scelte (computer): menu a tendina nostro che si apre sempre verso il basso.
   Sul telefono resta il menu del telefono. Il menu vero resta nascosto e fa il lavoro (prezzo, foto, carrello). */
(function () {
  var mq = window.matchMedia('(min-width: 990px) and (pointer: fine)');
  function close(dd) { dd.classList.remove('is-open'); dd.querySelector('.maka-dd__btn').setAttribute('aria-expanded', 'false'); }
  function closeAll(except) { document.querySelectorAll('.maka-dd.is-open').forEach(function (d) { if (d !== except) close(d); }); }
  function build(wrap) {
    var sel = wrap.querySelector('select'), box = wrap.querySelector('.select');
    if (!sel || !box || wrap.querySelector('.maka-dd')) return;
    var dd = document.createElement('div'); dd.className = 'maka-dd';
    var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'maka-dd__btn';
    btn.setAttribute('aria-haspopup', 'listbox'); btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML = '<span class="maka-dd__val"></span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
    btn.firstChild.textContent = sel.value;
    var list = document.createElement('ul'); list.className = 'maka-dd__list'; list.setAttribute('role', 'listbox');
    [].forEach.call(sel.options, function (o, i) {
      var li = document.createElement('li'), na = o.textContent.trim() !== o.value;
      li.setAttribute('role', 'option'); li.setAttribute('data-i', i);
      li.innerHTML = '<span></span>' + (na ? '<em>esaurito</em>' : '');
      li.firstChild.textContent = o.value;
      if (na) li.className = 'is-na';
      if (i === sel.selectedIndex) { li.classList.add('is-sel'); li.setAttribute('aria-selected', 'true'); }
      list.appendChild(li);
    });
    dd.appendChild(btn); dd.appendChild(list);
    box.parentNode.insertBefore(dd, box.nextSibling);
    wrap.classList.add('is-enh');
    var hot = null;
    function setHot(li, scroll) {
      if (hot) hot.classList.remove('is-hot');
      hot = li; if (!li) return;
      li.classList.add('is-hot');
      if (scroll) { var top = li.offsetTop, bot = top + li.offsetHeight; if (top < list.scrollTop) list.scrollTop = top - 6; else if (bot > list.scrollTop + list.clientHeight) list.scrollTop = bot - list.clientHeight + 6; }
    }
    function pick(i) {
      close(dd); i = +i;
      if (i === sel.selectedIndex) return;
      sel.selectedIndex = i; btn.firstChild.textContent = sel.value;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    }
    btn.addEventListener('click', function () {
      var open = !dd.classList.contains('is-open');
      closeAll(dd); dd.classList.toggle('is-open', open); btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { var s = list.querySelector('.is-sel') || list.firstChild; list.scrollTop = Math.max(0, s.offsetTop - 80); setHot(s, false); }
    });
    list.addEventListener('click', function (e) { var li = e.target.closest('li'); if (li) pick(li.getAttribute('data-i')); });
    list.addEventListener('mousemove', function (e) { var li = e.target.closest('li'); if (li && li !== hot) setHot(li, false); });
    dd.addEventListener('keydown', function (e) {
      var open = dd.classList.contains('is-open');
      if (e.key === 'Escape' && open) { close(dd); btn.focus(); }
      else if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        if (!open) { btn.click(); return; }
        var n = e.key === 'ArrowDown' ? hot && hot.nextElementSibling : hot && hot.previousElementSibling;
        if (n) setHot(n, true);
      } else if ((e.key === 'Enter' || e.key === ' ') && open && hot) { e.preventDefault(); pick(hot.getAttribute('data-i')); btn.focus(); }
    });
  }
  function run() { if (mq.matches) document.querySelectorAll('.maka-pp .maka-vdrop:not(.is-enh)').forEach(build); }
  run();
  document.addEventListener('click', function (e) { if (!e.target.closest('.maka-dd')) closeAll(); });
  /* dopo ogni scelta Shopify ridisegna il blocco varianti: lo ricostruiamo */
  var raf;
  document.querySelectorAll('.maka-pp').forEach(function (root) {
    new MutationObserver(function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(run); }).observe(root, { childList: true, subtree: true });
  });
  if (mq.addEventListener) mq.addEventListener('change', run);
})();

/* v2.3.2 recensioni: data italiana, voto con virgola, stelle nel riepilogo */
(function(){function txt(el){for(var i=0;i<el.childNodes.length;i++){var n=el.childNodes[i];if(n.nodeType===3&&n.nodeValue.trim())return n}return null}function fix(w){w.querySelectorAll('.jm-reviewer-info__details > .jm-cluster > .jm-text').forEach(function(s){var t=txt(s);if(!t||s.getAttribute('data-mk')===t.nodeValue)return;var m=t.nodeValue.trim().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);if(!m)return;t.nodeValue=('0'+m[2]).slice(-2)+'/'+('0'+m[1]).slice(-2)+'/'+m[3];s.setAttribute('data-mk',t.nodeValue)});var p=w.querySelector('.jm-average-rating-display .jm-cluster > p');var t=p&&txt(p);if(t){var raw=t.nodeValue.trim(),v=parseFloat(raw.replace(',','.'));if(!isNaN(v)){if(raw.indexOf('.')>-1)t.nodeValue=v.toFixed(1).replace('.',',');var pc=Math.max(0,Math.min(100,v/5*100))+'%';if(p.style.getPropertyValue('--mk-p')!==pc)p.style.setProperty('--mk-p',pc);p.classList.add('maka-rv-avg')}}}function watch(w){var busy=false;fix(w);new MutationObserver(function(){if(busy)return;busy=true;requestAnimationFrame(function(){fix(w);busy=false})}).observe(w,{childList:true,subtree:true,characterData:true})}var tries=0;(function find(){var w=document.getElementById('judgeme_product_reviews');if(w&&w.querySelector('.jm-review-widget'))return watch(w);if(++tries<60)setTimeout(find,500)})()})();
/* v2.5 coupon da spuntare (scheda prodotto) */
(function () {
  var box = document.querySelector('[data-maka-coupon]');
  if (!box) return;
  var omni = box.parentElement && box.parentElement.querySelector(':scope > [id$="__omnibus"]');
  if (omni) omni.after(box);
  var chk = box.querySelector('[data-maka-coupon-chk]');
  var save = box.querySelector('[data-maka-coupon-save]');
  var code = box.getAttribute('data-code');
  var perc = parseFloat(box.getAttribute('data-perc')) || 0;
  function price() {
    var el = document.querySelector('[id^="price-"] .price__sale .price-item--last, [id^="price-"] .price__regular .price-item--regular');
    var wrap = document.querySelector('[id^="price-"] .price');
    if (wrap && wrap.classList.contains('price--on-sale')) el = document.querySelector('[id^="price-"] .price__sale .price-item--last') || el;
    if (!el) return 0;
    var t = el.textContent.replace(/[^\d,.]/g, '');
    if (t.indexOf(',') > -1) t = t.replace(/\./g, '').replace(',', '.');
    return parseFloat(t) || 0;
  }
  function paint() {
    var p = price();
    if (save) save.textContent = p ? 'Risparmi ' + (Math.floor(Math.round(p * 100) * perc / 100) / 100).toFixed(2).replace('.', ',') + ' € al pagamento' : '';
    box.classList.toggle('is-on', chk.checked);
  }
  function post(body) {
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); });
  }
  chk.addEventListener('change', function () {
    var on = chk.checked;
    box.classList.add('is-busy');
    var job = on
      ? fetch('/discount/' + encodeURIComponent(code) + '?redirect=%2Fcart.js', { credentials: 'same-origin' }).then(function () { return post({ discount: code }); })
      : post({ discount: '' }).then(function (c) { document.cookie = 'discount_code=; Max-Age=0; path=/'; return c; });
    job.then(function () {
      try { if (on) localStorage.setItem('maka_coupon', code); else localStorage.removeItem('maka_coupon'); } catch (e) {}
    }).catch(function () { chk.checked = !on; }).then(function () { box.classList.remove('is-busy'); paint(); });
  });
  var pr = document.querySelector('[id^="price-"]');
  if (pr) new MutationObserver(paint).observe(pr, { childList: true, subtree: true, characterData: true });
  paint();
  fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (c) {
      var on = (c.discount_codes || []).some(function (d) { return String(d.code).toUpperCase() === code.toUpperCase(); });
      if (on !== chk.checked) { chk.checked = on; paint(); }
    }).catch(function () {});
})();
